export enum IrradianceGraphTypeEnum {
  IrradianceVsACPower = 0,
  ACPowerVsDCPower = 1,
  ACPower = 2
}
export enum SiteTabEnum {
  OverView = 0,
  Energy = 1,
  Utilites = 2,
  SolarDashboard = 3
}
export enum SiteStepperEnum {
  SiteCreation = 0,
  ConnectionDetails = 1,
  ShiftDetails = 2,
  ProcessAndLoadDetails = 3,
  GroupConfiguration = 4,
  ReservesAndSources = 5,
  AlertsConfiguration = 6,
  WidgetConfiguration = 7,
  ReportConfiguration = 8,
  DataAcquisitionLayout = 9,
  TreeConfiguration = 10,
  ClickAndNavigationDetails = 11
}
export enum ActionModeEnum {
  Creating = 1,
  Editing = 2,
  Viewing = 3,
  Deleting = 4,
  CreatingFirstLevel = 5,
  Reseted = 6,
  Saved = 7
}
export enum BenchSubItemEnum {
  BenchStatus = 1,
  BenchImage = 2,
  BenchRunningEfficiency = 3,
  BenchTrends = 4
}
export enum AllowedSiteSelectionEnum {
  SINGLE = '1',
  MULTIPLE = '2',
  NONE = '0'
}
